<template>
  <v-dialog
    v-model="dialog"
    width="50vw"
    scrollable
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly"
  >
    <v-card>
      <v-card-title class="text-start headline">
        <v-row>
          <v-col v-if="bioactiveSelected">
            Actualizar reactivación

            {{ bioactiveSelected.identificationName }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-expansion-panels multiple>
            <v-expansion-panel
              v-if="
                bioactiveSelected &&
                bioactiveSelected.moType == 'bacteria' &&
                bioactiveSelected.identificationName !==
                  'Streptomyces griseoviridis'
              "
            >
              <v-expansion-panel-header>
                Pruebas bioquímicas
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-form v-model="valid2" ref="form2" lazy-validation>
                  <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="hasBiochemicalTests"
                        label="Pasa"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row class="my-2">
                    <v-col
                      cols="12"
                      sm="4"
                      v-for="item in bcTestItems"
                      :key="item.text"
                      class="my-0 py-0"
                    >
                      <v-select
                        v-model="form.bcTest[item.value]"
                        :items="bcTestOptions"
                        outlined
                        dense
                        required
                        :label="item.text"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header> Morfología </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="hasColonialMorphology"
                        label="Pasa"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-text-field
                    label="Cepa entificada"
                    dense
                    outlined
                    disabled
                    class="mt-1"
                    v-model="nameIdentification"
                  >
                  </v-text-field>
                  <!-- bacteria -->
                  <v-row
                    v-if="
                      bioactiveSelected &&
                      bioactiveSelected.moType === 'bacteria'
                    "
                  >
                    <v-col cols="12" sm="6">
                      <v-select
                        v-model="form.colonyMorphology.shape"
                        :rules="validation('forma', 'F')"
                        :items="shape"
                        outlined
                        dense
                        required
                        label="Forma"
                      ></v-select>
                      <v-select
                        v-model="form.colonyMorphology.margin"
                        :rules="validation('borde')"
                        :items="margin"
                        outlined
                        dense
                        required
                        label="Borde"
                      ></v-select>
                      <v-select
                        v-model="form.colonyMorphology.elevation"
                        :rules="validation('elevación', 'F')"
                        :items="elevation"
                        outlined
                        dense
                        required
                        label="Elevación"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-select
                        v-model="form.colonyMorphology.surface"
                        :rules="[
                          () => form.colonyMorphology.surface.length > 0,
                        ]"
                        :items="surface"
                        multiple
                        outlined
                        dense
                        required
                        label="Superficie"
                      >
                        <template v-slot:selection="{ item, index }">
                          <span v-if="index === 0" class="mr-2">{{
                            item.text
                          }}</span>
                          <span v-if="index === 1" class="grey--text caption">
                            ({{ form.colonyMorphology.surface.length - 1 }}
                            más)
                          </span>
                        </template>
                      </v-select>
                      <v-select
                        v-model="form.colonyMorphology.opacity"
                        :rules="validation('opacidad', 'F')"
                        :items="opacity"
                        outlined
                        dense
                        required
                        label="Opacidad"
                      ></v-select>
                      <v-select
                        v-model="form.colonyMorphology.color"
                        :rules="validation('color')"
                        :items="color"
                        outlined
                        dense
                        required
                        label="Color"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col cols="12" sm="6">
                      <v-select
                        v-model="form.colonyMorphology.obverse"
                        :rules="validation('color anverso')"
                        :items="fungiColor"
                        outlined
                        dense
                        required
                        label="Color anverso"
                      ></v-select>
                      <v-select
                        v-model="form.colonyMorphology.reverse"
                        :rules="validation('color reverso')"
                        :items="fungiColor"
                        outlined
                        dense
                        required
                        label="Color reverso"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-select
                        v-model="form.colonyMorphology.texture"
                        :rules="validation('textura', 'F')"
                        :items="fungiTexture"
                        outlined
                        dense
                        required
                        label="Textura"
                      ></v-select>
                      <v-select
                        v-model="form.colonyMorphology.growth"
                        :rules="validation('crecimiento')"
                        :items="growth"
                        outlined
                        dense
                        required
                        label="Crecimiento"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Observaciones
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col>
                    <v-textarea
                      outlined
                      name="input-7-4"
                      label="Observaciones"
                      v-model="observations"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Evidencia fotografica
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-form
                  ref="formEvidence"
                  lazy-validation
                  v-if="reactivation && reactivation.status == 'REACTIVATING'"
                >
                  <v-row align="center">
                    <v-col>
                      <v-file-input
                        v-model="files"
                        counter
                        multiple
                        show-size
                        :rules="validation('Imagen de cepa')"
                        accept="image/png, image/jpeg, image/bmp"
                        truncate-length="50"
                        label="Cargar imagen de cepa"
                        prepend-icon="mdi-file"
                      >
                        <template v-slot:selection="{ text }">
                          <v-chip small label color="primary">
                            {{ text }}
                          </v-chip>
                        </template>
                      </v-file-input>
                    </v-col>
                    <v-col>
                      <v-btn
                        small
                        rounded
                        color="primary"
                        @click="addEvidence"
                        :loading="uploadingEvidence"
                      >
                        <v-icon> mdi-paperclip </v-icon>
                        Añadir evidencia
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>

                <v-carousel
                  v-if="
                    reactivation.deliveryImgs &&
                    reactivation.deliveryImgs.length > 0
                  "
                >
                  <v-carousel-item
                    v-for="(item, i) in reactivation.deliveryImgs"
                    :key="i"
                  >
                    <v-row class="text-end">
                      <v-col cols="12">
                        <v-btn color="primary" small @click="showPhoto">
                          <v-icon small> mdi-magnify-expand </v-icon>
                        </v-btn>
                      </v-col>
                      <v-col align="center">
                        <v-img
                          alt="Imagen altamente responsiva"
                          :src="item"
                          max-height="400"
                          max-width="400"
                          contain
                        ></v-img>
                      </v-col>
                    </v-row>
                  </v-carousel-item>
                </v-carousel>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-card-text>
      <!-- Actions -->
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                @click="dialog = false"
                depressed
                dark
                block
                color="gray"
                :disabled="loading"
              >
                Cerrar
              </v-btn>
            </v-col>
            <v-col
              v-if="
                reactivation &&
                reactivation.status == 'REACTIVATING' &&
                user.role == 'CEPARIUM'
              "
            >
              <v-btn
                :loading="loading"
                depressed
                block
                color="primary"
                @click="update"
              >
                Actualizar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
      <PhotosModals
        :img="photos"
        :visible="isVisiblePhoto"
        @hideSubSampleModal="hidePhotos"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
// Validations
import {
  requiredFValidation,
  requiredValidation,
  requiredMultiple,
} from "@/helpers/validations.js";
// library
//component
import PhotosModals from "@/components/utils/PhotosModals.vue";
export default {
  components: {
    PhotosModals,
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      hasBiochemicalTests: false,
      hasColonialMorphology: false,
      nameIdentification: "",
      observations: "",
      //   dialog: false,
      loading: false,
      // loader: false,
      // search: "",
      // stepper
      // stepper: 1,
      // data form
      // identification: "",
      form: {
        colonyMorphology: {
          shape: "",
          margin: "",
          elevation: "",
          surface: [],
          color: "",
          opacity: "",
          obverse: "",
          reverse: "",
          texture: "",
          growth: "",
        },
        bcTest: {
          gram: null,
          KOH: null,
          catalase: null,
          oxidase: null,
          simmonsCitrate: null,
          MIO: null,
          LIA: null,
          TSI: null,
          christensenUrea: null,
        },
      },
      // items
      valid: true,
      valid2: true,
      bcTestItems: [
        { text: "Gram", value: "gram" },
        { text: "KOH", value: "KOH" },
        // { text: "Catalasa", value: "catalase" },
        { text: "Oxidasa", value: "oxidase" },
        // { text: "Citrato de simmons", value: "simmonsCitrate" },
        // { text: "MIO", value: "MIO" },
        // { text: "LIA", value: "LIA" },
        // { text: "TSI", value: "TSI" },
        // { text: "Urea de Chritensen", value: "christensenUrea" },
      ],
      bcTestOptions: [
        // { text: "Sin test", value: 0 },
        { text: "Negativo", value: false },
        { text: "Positivo", value: true },
      ],
      // user info
      user: JSON.parse(localStorage.getItem("user")),
      files: [],
      uploadingEvidence: false,
      isVisiblePhoto: false,
      photos: [],
    };
  },
  computed: {
    ...mapState("bioactives", ["bioactiveSelected", "reactivation"]),
    ...mapState("strain", [
      "shape",
      "margin",
      "elevation",
      "surface",
      "opacity",
      "color",
      "fungiColor",
      "fungiTexture",
      "growth",
    ]),
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async created() {
    if (this.bioactiveSelected) {
      this.nameIdentification = this.bioactiveSelected.identificationName;
      if (this.reactivation.colonialMorphology) {
        this.form.colonyMorphology.shape =
          this.reactivation.colonialMorphology.shape;
        this.form.colonyMorphology.margin =
          this.reactivation.colonialMorphology.margin;
        this.form.colonyMorphology.elevation =
          this.reactivation.colonialMorphology.elevation;
        this.form.colonyMorphology.surface =
          this.reactivation.colonialMorphology.surface;
        this.form.colonyMorphology.color =
          this.reactivation.colonialMorphology.color;
        this.form.colonyMorphology.opacity =
          this.reactivation.colonialMorphology.opacity;
        this.form.colonyMorphology.obverse =
          this.reactivation.colonialMorphology.obverse;
        this.form.colonyMorphology.reverse =
          this.reactivation.colonialMorphology.reverse;
        this.form.colonyMorphology.texture =
          this.reactivation.colonialMorphology.texture;
        this.form.colonyMorphology.growth =
          this.reactivation.colonialMorphology.growth;
      } else {
        await this.fecthMorphology();
      }

      if (this.reactivation.bctest) {
        this.form.bcTest.gram = this.reactivation.bctest.gram;
        this.form.bcTest.KOH = this.reactivation.bctest.KOH;
        this.form.bcTest.catalase = this.reactivation.bctest.catalase;
        this.form.bcTest.oxidase = this.reactivation.bctest.oxidase;
        this.form.bcTest.simmonsCitrate =
          this.reactivation.bctest.simmonsCitrate;
        this.form.bcTest.MIO = this.reactivation.bctest.MIO;
        this.form.bcTest.LIA = this.reactivation.bctest.LIA;
        this.form.bcTest.TSI = this.reactivation.bctest.TSI;
        this.form.bcTest.christensenUrea =
          this.reactivation.bctest.christensenUrea;
      }

      if (this.reactivation.observations) {
        this.observations = this.reactivation.observations;
      }

      if (this.reactivation.hasBiochemicalTests) {
        this.hasBiochemicalTests = true;
      } else {
        this.hasBiochemicalTests = false;
      }

      if (this.reactivation.hasColonialMorphology) {
        this.hasColonialMorphology = true;
      } else {
        this.hasColonialMorphology = false;
      }
    }
  },
  methods: {
    ...mapActions("bioactives", [
      "getMorphology",
      "updateReactivation",
      "uploadStrainPhoto",
      "updateEvidenceReactivation",
    ]),
    ...mapMutations("bioactives", [
      "SET_FETCH_PRESERVED_LIST",
      "SET_FETCH_BIO_LIST",
    ]),
    // Form validations
    validation(name, type) {
      if (type === "F") {
        return requiredFValidation(name);
      } else {
        return requiredValidation(name);
      }
    },
    validationMultiple(name) {
      return requiredMultiple(name);
    },
    async fecthMorphology() {
      try {
        let response = await this.getMorphology({
          identification: this.bioactiveSelected.identification,
        });
        if (response) {
          if (!response.error) {
            let mophologyFound = response.mophologyFound;
            if (mophologyFound) {
              if (this.bioactiveSelected.moType == "bacteria") {
                this.form.colonyMorphology.shape = mophologyFound.shape
                  ? mophologyFound.shape
                  : "";
                this.form.colonyMorphology.margin = mophologyFound.margin
                  ? mophologyFound.margin
                  : "";
                this.form.colonyMorphology.elevation = mophologyFound.elevation
                  ? mophologyFound.elevation
                  : "";
                this.form.colonyMorphology.surface = mophologyFound.surface
                  ? mophologyFound.surface
                  : "";
                this.form.colonyMorphology.opacity = mophologyFound.opacity
                  ? mophologyFound.opacity
                  : "";
                this.form.colonyMorphology.color = mophologyFound.color
                  ? mophologyFound.color
                  : "";
              } else {
                this.form.colonyMorphology.obverse = mophologyFound.obverse
                  ? mophologyFound.obverse
                  : "";
                this.form.colonyMorphology.reverse = mophologyFound.reverse
                  ? mophologyFound.reverse
                  : "";
                this.form.colonyMorphology.texture = mophologyFound.texture
                  ? mophologyFound.texture
                  : "";
                this.form.colonyMorphology.growth = mophologyFound.growth
                  ? mophologyFound.growth
                  : "";
              }
            }
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al cargar morfología`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar morfología`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (e) {
        console.log(e);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar morfología`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async update() {
      try {
        this.loading = true;
        let payload = {
          reactivation: this.reactivation,
          colonyMorphology: this.form.colonyMorphology,
          bcTest: this.form.bcTest,
          hasBiochemicalTests: this.hasBiochemicalTests,
          hasColonialMorphology: this.hasColonialMorphology,
          observations: this.observations,
        };
        let response = await this.updateReactivation(payload);
        if (response) {
          if (!response.error) {
            this.SET_FETCH_PRESERVED_LIST(true);
            this.SET_FETCH_BIO_LIST(true);
            this.loading = false;
            this.dialog = false;
          } else {
            this.loading = false;
            this.$swal({
              icon: "error",
              title: `Algo actualizar reactivación`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.loading = false;
          this.$swal({
            icon: "error",
            title: `Algo actualizar reactivación`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (e) {
        this.loading = false;
        console.log(e);
        this.$swal({
          icon: "error",
          title: `Algo actualizar reactivación`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async addEvidence() {
      if (this.$refs.formEvidence.validate()) {
        try {
          this.uploadingEvidence = true;
          let files = [];
          for (let item of this.files) {
            let fileB64 = await this.getBase64(item);
            files.push(fileB64);
          }

          let imgs = [];
          for (let file of files) {
            let imgFile = this.dataURLtoFile(file);
            let form_data = new FormData();
            form_data.append("file", imgFile);
            const { urlImg } = await this.uploadStrainPhoto(form_data);
            imgs.push(urlImg);
          }

          let response = await this.updateEvidenceReactivation({
            reactivation: this.reactivation,
            imgs: imgs,
          });
          if (response) {
            this.files = [];
            this.reactivation.deliveryImgs = imgs;
            this.SET_FETCH_PRESERVED_LIST(true);
            this.SET_FETCH_BIO_LIST(true);
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al subir evidencia `,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al subir evidencia `,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.uploadingEvidence = false;
      }
    },
    dataURLtoFile(img) {
      let arr = img.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      // let newDate = this.getDatewithTime();
      return new File([u8arr], `delivery.png`, { type: mime });
    },
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    showPhoto() {
      this.photos = this.reactivation.deliveryImgs.map((element) => {
        return {
          title: "",
          src: element,
        };
      });
      this.isVisiblePhoto = true;
    },
    hidePhotos() {
      this.photos = [];
      this.isVisiblePhoto = false;
    },
  },
};
</script>
